import { httpClient } from '@bcba/client-auth';
import { GetPaginatedReceivedDigitalDossierAccessRequestsDto } from './dto/getPaginatedReceivedDigitalDossierAccessRequests.dto';
import {
  ExplorerListReceivedDigitalDossierAccessRequestsSerializer,
  PaginationSerializer,
} from '@bcba/serializers';
import {
  DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS,
  DigitalDossierSection,
} from '@bcba/types';

export const getReceivedDigitalDossierAccessRequests = async (
  params: GetPaginatedReceivedDigitalDossierAccessRequestsDto,
): Promise<
  PaginationSerializer<ExplorerListReceivedDigitalDossierAccessRequestsSerializer>
> => {
  const { data } = await httpClient.get(
    '/digital-dossier-access-requests/received',
    { params },
  );

  return data;
};

export const approveReceivedAccessRequest = async (
  uuid: string,
  accessibleSections?: DigitalDossierSection[],
) => {
  const { data } = await httpClient.patch(
    `/digital-dossier-access-requests/${uuid}`,
    {
      status: DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.APPROVED,
      accessibleSections,
    },
  );

  return data;
};

export const rejectReceivedAccessRequest = async (uuid: string) => {
  const { data } = await httpClient.patch(
    `/digital-dossier-access-requests/${uuid}`,
    { status: DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.REJECTED },
  );

  return data;
};

export const revokeAccessReceivedAccessRequest = async (uuid: string) => {
  const { data } = await httpClient.patch(
    `/digital-dossier-access-requests/${uuid}`,
    { status: DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.REVOKED },
  );

  return data;
};
